const configuredApiBase = import.meta.env.VITE_API_BASE ?? 'https://localhost:8000'

const resolveApiBase = () => {
    if (typeof window === 'undefined') {
        return configuredApiBase
    }

    if (window.location.hostname && window.location.hostname !== 'localhost') {
        return `${window.location.protocol}//${window.location.hostname}`
    }

    return configuredApiBase
}

export const API_BASE = resolveApiBase()

export function apiFetch(input: RequestInfo | URL, init: RequestInit = {}) {
    return fetch(input, {
        ...init,
        credentials: init.credentials ?? 'include',
    })
}
